// extracted by mini-css-extract-plugin
export default {"favourite":"favourite_favourite__3VDu2","errorMessage":"favourite_errorMessage__X6XjR","emptyList":"favourite_emptyList__5lYQ2"};